import { DateTime } from 'luxon';
import type { Locales } from '@/i18n/i18n-types';
import { getLuxonLocale } from '@/lib/utils';

const shortName = (value: string) => {
  const name = value.replace(/\.$/, '');
  return name.charAt(0).toUpperCase() + name.slice(1);
};

/**
 * "{dia}, {d} de {mmm}" of the Início campaign cards (HOME-06, HOME-08):
 * "Sex, 30 de out" (pt) / "Fri, Oct 30" (en), in the browser's zone.
 */
export function campaignDayLabel(iso: string, locale: Locales): string {
  const date = DateTime.fromISO(iso).setLocale(getLuxonLocale(locale));
  const weekday = shortName(date.toFormat('ccc'));
  const month = date.toFormat('MMM').replace(/\.$/, '');
  return locale === 'en'
    ? `${weekday}, ${month} ${date.day}`
    : `${weekday}, ${date.day} de ${month}`;
}
